import React from 'react';
import { useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { Text } from 'ui-components/components/text/text';
import { TextType } from 'ui-components/components/text/text-type';

import { PricePerLabelFootnote } from './price-per-label-footnote';
import style from './style.module.css';
import { getSalesEmail } from '../../../../../../constants/email-addresses';
import Global from '../../../../../../store/global-selectors';
import { useManageSubscriptionDrawerContext } from '../../../context/manage-subscription-drawer-context';
import { messages } from '../../../messages';
import { PlanGridConfig, useManageSubscriptionDrawerSectionVisibility } from '../use-manage-subscription-drawer-section-visibility';

export const ManageSubscriptionDrawerFooter = () => {
  const sellerHomeCountry = useSelector(Global.selectSellerHomeCountry);
  const sellerSalesEmail = getSalesEmail(sellerHomeCountry);
  const subscriptionData = useSelector(Global.selectSellerSubscriptionData);
  const { allPlans, currentBillingPlan } = subscriptionData ?? {};
  const { selectedPlanId, isOnAnnualBilling, referencePlans } = useManageSubscriptionDrawerContext();

  const { planGridConfig } = useManageSubscriptionDrawerSectionVisibility();
  const isSelectedPlanAnnual = referencePlans.find((p) => p.billingPlanId === selectedPlanId)?.isOnAnnualBilling ?? isOnAnnualBilling;
  const subscriptionMessage = isSelectedPlanAnnual ? messages.howAnnualSubscriptionWorksNotice : messages.howSubscriptionWorksNotice;

  return (
    <div className={style.wrapper}>
      {/* TODO: Derive visibility from plan's usageBillingDetails.hasUsageBilling instead of config-driven check */}
      {planGridConfig !== PlanGridConfig.GbbLineup && <PricePerLabelFootnote allPlans={allPlans} currentBillingPlan={currentBillingPlan} />}
      <Text
        className={style.centered}
        formattedMessageValues={{
          a: (chunks) => (
            <Button className={style['sales-email-button']} href={`mailto:${sellerSalesEmail}`} theme='link'>
              {chunks}
            </Button>
          ),
          email: sellerSalesEmail,
        }}
        textType={TextType.Caption}
        value={subscriptionMessage}
      />
    </div>
  );
};
